import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import UserDetailsCard from "../components/report/UserDetailsCard";

const UserDetails = ({ token, admin }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

	useEffect(() => {
		if (!admin || !admin.user_detail) {
			history.push('/admin/dashboard')
		}
	}, [])

	const handleToggle = () => {
		setToggled(!toggled);
	}

	return (
		<div className="admin-page-container">
			  <Sidebar toggled={toggled} setToggled={handleToggle} />
			<div className="admin-page">
				<Topbar handleToggle={handleToggle} />
				<div className="admin-content">
					<UserDetailsCard 
						role="operator"
						token={token}
						country={admin?.country}
						stampSetting={admin?.stamp}
                        tokenSetting={admin?.token}
                        pointSetting={admin?.loyalty_point}
					/>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = state => {
	return {
		admin: state.admin.admin,
		token: state.admin.token,
	};
};

export default connect(mapStateToProps, null)(UserDetails);
